<template>
	<!-- Main content -->

	<div class="row">

		<div class="col-md-12">
			<div class="box box-solid">

				<div class="box-header with-border">
					<h3 class="box-title"><i class="fa fa-search"></i> <b>Resultado da Consulta Analítica</b></h3>
				</div>

				<div class="box-body">
					<div class="nav-tabs-custom">
						<ul class="nav nav-tabs">
							<li class="active"><a href="#tab_dados_consulta" data-toggle="tab"><i class="fa fa-file-text-o"></i> Dados da Consulta</a></li>
							<li v-if="resultado.cabecalho.consulta == 'PESSOA_FISICA'"><a href="#tab_dados_pessoais" data-toggle="tab"><i class="fa fa-user"></i> Dados Pessoais</a></li>
							<li v-if="resultado.cabecalho.consulta == 'PESSOA_JURIDICA'"><a href="#tab_dados_empresa" data-toggle="tab"><i class="fa fa-bank"></i> Dados da Empresa</a></li>
							<li><a href="#tab_enderecos" data-toggle="tab"><i class="fa fa-map-marker"></i> Localização</a></li>
							<li><a href="#tab_telefones" data-toggle="tab"><i class="fa fa-phone"></i> Telefones</a></li>
							<li v-if="resultado.cabecalho.consulta == 'PESSOA_FISICA'"><a href="#tab_ocupacoes" data-toggle="tab"><i class="fa fa-wrench"></i> Ocupações</a></li>
							<li v-if="resultado.cabecalho.consulta == 'PESSOA_FISICA'"><a href="#tab_sociedades" data-toggle="tab"><i class="fa fa-bank"></i> Sociedades</a></li>
							<li v-if="resultado.cabecalho.consulta == 'PESSOA_JURIDICA'"><a href="#tab_socios" data-toggle="tab"><i class="fa fa-users"></i> Sócios</a></li>
						</ul>
						<div class="tab-content">
							<div class="tab-pane active" id="tab_dados_consulta">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr class="">
													<th>Protocolo</th>
													<th>Consulta</th>
													<th>Documento</th>
													<th>Data da Consulta</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>{{resultado.cabecalho.protocoloTransacao}}</td>
													<td>{{resultado.cabecalho.consulta}}</td>
													<td>{{resultado.cabecalho.entrada}}</td>
													<td>{{resultado.cabecalho.dataHora}}</td>
												</tr>
											</tbody>

										</table>
									</div>
								</div>
							</div>
							<div v-if="resultado.cabecalho.consulta == 'PESSOA_FISICA'" class="tab-pane" id="tab_dados_pessoais">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr>
													<th>CPF</th>
													<th>Nome</th>
													<th>Sexo</th>
													<th>Dt. Nasc</th>
													<th>Idade</th>
													<th>Escolaridade</th>
													<th>Nome da Mãe</th>
												</tr>
											</thead>

											<tbody>
												<tr>
													<td>{{resultado.cadastro.cpf}}</td>
													<td>{{resultado.cadastro.nome}}</td>
													<td>{{resultado.cadastro.sexo}}</td>
													<td>{{resultado.cadastro.dataNascimento}}</td>
													<td>{{resultado.cadastro.idade}}</td>
													<td>{{resultado.cadastro.grauInstrucao}}</td>
													<td>{{resultado.cadastro.maeNome}}</td>
												</tr>
											</tbody>

										</table>
									</div>
								</div>
							</div>
							<div v-if="resultado.cabecalho.consulta == 'PESSOA_JURIDICA'" class="tab-pane" id="tab_dados_empresa">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr>
													<th>CNPJ</th>
													<th>Razão Social</th>
													<th>Fantasia</th>
													<th>Descrição CNAE</th>
													<th>Porte</th>
													<th>Data de Abertura</th>
												</tr>
											</thead>

											<tbody>
												<tr>
													<td>{{resultado.cadastro.cnpj}}</td>
													<td>{{resultado.cadastro.razaoSocial}}</td>
													<td>{{resultado.cadastro.nomeFantasia}}</td>
													<td>{{resultado.cadastro.cnaeDescricao}}</td>
													<td>{{resultado.cadastro.porteEmpresa}}</td>
													<td>{{resultado.cadastro.dataAbertura}}</td>
												</tr>
											</tbody>

										</table>
									</div>
								</div>
							</div>
							<div class="tab-pane" id="tab_enderecos">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr>
													<td style="width:20%">Endereço</td>
													<td style="width:10%">Número</td>
													<td style="width:10%">Complemento</td>
													<td style="width:20%">Bairro</td>
													<td style="width:15%">Cidade</td>
													<td style="width:7%">UF</td>
													<td style="width:10%">CEP</td>
												</tr>
											</thead>

											<tbody>
												<tr v-for="item in resultado.enderecos">
													<td>{{item.tipoLogradouro}} {{item.logradouro}}</td>
													<td>{{item.numero}}</td>
													<td>{{item.complemento}}</td>
													<td>{{item.bairro}}</td>
													<td>{{item.cidade}}</td>
													<td>{{item.uf}}</td>
													<td>{{item.cep}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div  class="tab-pane" id="tab_telefones">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr>
													<td style=" width:25%">Telefone</td>
													<td style=" width:25%">Operadora</td>
													<td style=" width:25%">Relação</td>
													<td style=" width:25%">Tags</td>
												</tr>
											</thead>

											<tbody>
												<template v-if="resultado.telefones != null && resultado.telefones.fixos != null">
													<tr v-for="item in resultado.telefones.fixos">
														<td>{{item.telefone}}</td>
														<td>{{item.operadora}}</td>
														<td>{{item.relacao}}</td>
														<td><span v-for="tag in item.tags">{{tag}}</span></td>
													</tr>
												</template>
												<template v-if="resultado.telefones != null && resultado.telefones.moveis != null">
													<tr v-if="resultado.telefones.moveis" v-for="item in resultado.telefones.moveis">
														<td>{{item.telefone}}</td>
														<td>{{item.operadora}}</td>
														<td>{{item.relacao}}</td>
														<td><span v-for="tag in item.tags">{{tag}}</span></td>
													</tr>
												</template>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div v-if="resultado.cabecalho.consulta == 'PESSOA_FISICA'" class="tab-pane" id="tab_ocupacoes">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr>
													<th>CNPJ</th>
													<th>Razão Social</th>
													<th>Área de Atuação</th>
													<th>Cargo</th>
													<th>Faixa Salarial</th>
												</tr>
											</thead>

											<tbody>
												<tr v-for="item in resultado.rendaEmpregador">
													<td>{{item.documentoEmpregador}}</td>
													<td>{{item.empregador}}</td>
													<td>{{item.setorEmpregador}}</td>
													<td>{{item.cboDescricao}}</td>
													<td>{{item.rendaEstimada}} ({{item.faixaRenda}})</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div v-if="resultado.cabecalho.consulta == 'PESSOA_FISICA'" class="tab-pane" id="tab_sociedades">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr>
													<th>CNPJ</th>
													<th>Razão Social</th>
													<th>Cargo</th>
													<th>Participação (%)</th>
													<th>Sócio Desde</th>
												</tr>
											</thead>

											<tbody>
												<tr v-for="item in resultado.participacoesEmpresas">
													<td>{{item.documento}}</td>
													<td>{{item.nome}}</td>
													<td>{{item.qualificacaoSocio}}</td>
													<td>{{item.participacao}}</td>
													<td>{{item.dataEntrada}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div v-if="resultado.cabecalho.consulta == 'PESSOA_JURIDICA'" class="tab-pane" id="tab_socios">
								<div class="row">
									<div class="col-md-12 form-group">
										<table class="table table-bordered table-striped table-hover">
											<thead>
												<tr>
													<td>Documento</td>
													<td>Nome</td>
													<td>Cargo</td>
													<td>Participação (%)</td>
													<td>Sócio desde</td>
												</tr>
											</thead>

											<tbody>
												<tr v-for="item in resultado.quadroSocietario">
													<td>{{item.documento}}</td>
													<td>{{item.nome}}</td>
													<td>{{item.qualificacaoSocio}}</td>
													<td>{{item.participacao}}</td>
													<td>{{item.dataEntrada}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- /.content -->
</template>



<script>

	export default {
		props: ['resultado'],
		components: {

		},
		data: () => ({
			
		}),
		mounted() {
			
		},
		methods: {

		},
		watch: {
			
		}
	}
</script>

<style scoped>
	.nav-tabs-custom>.nav-tabs>li.active {
		border-top-color: #d58512;
	}
</style>



// WEBPACK FOOTER //
// ResultadoAnalitica.vue?157c5086